export default "/static/assets/easel-pie-chart.cb169b680fb004f84fc4054523fb0055.svg";